export enum PlPiTopic {
  DEBT_COLLECTION = 'windykacja',
  CONTACT = 'kontakt'
}
